// The bunk floorplan geometry — the CLIENT twin of the server's BunkGeometry (ART-147). It derives a slot's
// side/group/tier for LAYOUT (positioning a bunk on the coach diagram); the server sends the human CODE on
// each bunk, so this and the C# copy assert the same canonical 12-slot ordering and cannot drift silently
// (the CrewParties.Resolve parity pattern). A US coach is 2 SIDES × 2 SECTIONS × 3 TIERS = 12; a smaller coach
// is the first `count` of that ordering.
//
// Slot loop: side [D, P] → group [F, B] → tier [B, M, T], so slot 0 = D/F/B and slot 11 = P/B/T.

export type Side = "D" | "P";
export type Group = "F" | "B";
export type Tier = "B" | "M" | "T";

export const bunkSide = (slot: number): Side => (Math.floor(slot / 6) === 0 ? "D" : "P");
export const bunkGroup = (slot: number): Group => (Math.floor((slot % 6) / 3) === 0 ? "F" : "B");
export const bunkTier = (slot: number): Tier => (["B", "M", "T"] as const)[slot % 3];

/** "D/F/B" — matches the server's canonical code exactly. */
export const bunkCode = (slot: number): string => `${bunkSide(slot)}/${bunkGroup(slot)}/${bunkTier(slot)}`;

export const SIDE_LABEL: Record<Side, string> = { D: "Driver side", P: "Passenger side" };
export const GROUP_LABEL: Record<Group, string> = { F: "Front", B: "Back" };
export const TIER_LABEL: Record<Tier, string> = { B: "Bottom", M: "Middle", T: "Top" };

export const bunkLong = (slot: number): string =>
  `${bunkSide(slot) === "D" ? "Driver" : "Passenger"} · ${GROUP_LABEL[bunkGroup(slot)]} · ${TIER_LABEL[bunkTier(slot)]}`;

/** The count picker offers these; 12 is the ceiling the 2×2×3 grid expresses. */
export const SELECTABLE_BUNK_COUNTS = [8, 10, 12] as const;
